import { render } from "./Light.vue?vue&type=template&id=5f67e660&scoped=true"
const script = {}

import "./Light.vue?vue&type=style&index=0&id=5f67e660&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f67e660"]])

export default __exports__